import CustomReportAreaChart from '../../Graphs/CustomReportAreaChart';
import { GRAPH_TYPES } from '../../consts';
import CustomReportBarChart from '../../Graphs/CustomReportBarChart';
import CustomReportStackedAreaChart from '../../Graphs/CustomReportStackedAreaChart';

const GRAPH_BY_TYPE = {
  default: CustomReportAreaChart,
  [GRAPH_TYPES.BAR]: CustomReportBarChart,
  [GRAPH_TYPES.STACKED]: CustomReportStackedAreaChart
};

const BaseWidget = ({ graph, graphProps }) => {
  let graphType = graph.type ?? GRAPH_TYPES.LINE;
  let RenderGraph = GRAPH_BY_TYPE[graphType] ?? GRAPH_BY_TYPE.default;

  if (
    graphProps.isMultiSeries ||
    !Object.keys(GRAPH_BY_TYPE).includes(graphType)
  ) {
    RenderGraph = GRAPH_BY_TYPE.default;
    graphType = 'defaultGraph';
  }

  return (
    <RenderGraph {...(graphProps[graphType] ?? graphProps.defaultGraph)} />
  );
};
export default BaseWidget;
